import { render, staticRenderFns } from "./WorkshopApprovedList.vue?vue&type=template&id=50166264&scoped=true&"
import script from "./WorkshopApprovedList.vue?vue&type=script&lang=js&"
export * from "./WorkshopApprovedList.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopApprovedList.vue?vue&type=style&index=0&id=50166264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50166264",
  null
  
)

export default component.exports